<template>
  <Modal :open="open" :close="close">
    <transition
      enter-active-class="duration-300 ease-out"
      enter-from-class="transform opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="transform opacity-0"
      mode="out-in"
    >
      <div v-if="open" class="p-[20px]">
        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
          >New Instance Name</label
        >
        <input
          v-model="instanceName"
          type="text"
          class="w-[300px] border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
        />
        <p
          class="text-sm text-red-500 mt-2 h-[20px]"
          v-if="showValidationMessage"
        >
          Please use "_" instead of empty space
        </p>
        <p class="text-sm text-red-500 mt-2 h-[20px]" v-else>{{}}</p>
        <div class="mt-4 flex items-center justify-between">
          <button
            @click="close"
            class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          >
            Cancel
          </button>
          <button
            :disabled="showValidationMessage"
            @click="updateInstanceName"
            :class="
              showValidationMessage
                ? 'bg-gray-200 active:bg-gray-300'
                : 'bg-emerald-500 active:bg-emerald-600'
            "
            class="text-white font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          >
            Confirm
          </button>
        </div>
      </div>
    </transition>
  </Modal>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import Modal from "@/components/Shared/Modal/Base";

export default {
  name: "InstanceNameEditModal",
  components: {
    Modal
  },
  data() {
    return {
      instanceName: "",
      showValidationMessage: false
    };
  },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    close: {
      type: Function,
      required: true
    },
    componentId: {
      type: String,
      required: true
    },
    instanceId: {
      type: String,
      required: true
    },
    draftId: {
      type: String
    }
  },
  mounted() {
    if (this.prevInstanceName) {
      this.instanceName = this.prevInstanceName;
    }
  },
  computed: {
    prevInstanceName() {
      if (
        this.getInstanceInfo.length &&
        this.getInstanceInfo.find((item) => item.id === this.instanceId)
      ) {
        return this.getInstanceInfo
          .find((item) => item.id === this.instanceId)
          .instance_name.split("|")[1];
      } else {
        return null;
      }
    },
    ...mapGetters(["getInstanceInfo", "getRegion"])
  },
  watch: {
    // check whether instance name includes empty space
    instanceName() {
      if (this.instanceName.includes(" ")) {
        this.showValidationMessage = true;
      } else {
        this.showValidationMessage = false;
      }
    },
    prevInstanceName() {
      if (this.prevInstanceName) {
        this.instanceName = this.prevInstanceName;
      }
    }
  },
  methods: {
    updateInstanceName() {
      if (this.instanceName) {
        this.$store
          .dispatch(Actions.UPDATE_INSTANCE_NAME, {
            region: this.getRegion,
            componentId: this.componentId,
            instanceId: this.instanceId,
            draftId: this.draftId,
            instanceName: this.instanceName
          })
          .then(() => {
            this.handleGoBack();
          });
      } else {
        this.$store.dispatch(
          Actions.ADD_COMPONENT_ERRORS,
          "Instance name cannot be empty!"
        );
      }
      this.close();
    },
    handleGoBack() {
      this.$router.back();
    }
  }
};
</script>
